<template lang="pug">
div(class='h-12')
  BaseFormSelect(
    id='brandSelector'
    v-model='selectedBrand'
    name='brandSelector'
    :options='brandsList'
    :classes='{ input: "h-full" }'
  )
</template>
<script setup lang="ts">
const { $algolia } = useNuxtApp()
const dealerData = useDealerLocator()
const route = useRoute()
const dealerLocator = $algolia.searchContexts.dealerLocator
const dealerLocatorBrands = $algolia.searchContexts.dealerLocatorBrands
const brands = ref<string[]>([])
const currentBrand = ref('')

onMounted(async () => {
  await getBrands()
  if (route.query?.brand) selectedBrand.value = route.query.brand.toString()
})

watch(
  () => route.query.brand,
  (newVal) => {
    selectedBrand.value = newVal ? newVal.toString() : ''
  }
)

const selectedBrand = computed({
  get: () => currentBrand.value,
  set: (newVal) => {
    if (!brands.value.includes(newVal)) return

    currentBrand.value = newVal
    dealerData.setBrand(newVal)

    // trigger new search
    dealerData.performSearch()

    // Update page to new sort
    navigateTo({ query: { brand: newVal || undefined } })
  },
})

const brandsList = computed(() => {
  // Turn the brands array into an object key value pair for FormKit data

  const formattedBrands = brands.value.map((brand) => ({ label: brand, value: brand }))
  formattedBrands.unshift({ label: 'All Brands', value: '' })

  return formattedBrands
})

async function getBrands() {
  try {
    // this is using a private method we use internally that gets the results but doesn't set the state.
    const { refinements } = await dealerLocatorBrands._search()

    // Get brand facet from search
    const brandFacetValues = refinements['brands.brand']

    // If we don't have any then return
    if (!brandFacetValues) return

    // Set brands equal to the values
    brands.value = brandFacetValues.map(({ value }) => value)
  } catch (error) {
    console.log('Unable to get brand facets')
  }
}
</script>
